
    /**
     * Conditional React Boot
     */
    if (document.documentElement.classList.contains('app-active')) {
      import('/src/main.tsx');
    }
  